import * as React from 'react';
import { formatDateDefault } from '@imposium-hub/components';

interface IExperiencesTableDateCell {
    cell: any; // React table 'cell' wrapper
    rendered?: boolean;
}

const ExperiencesTableDateCell: React.FC<IExperiencesTableDateCell> = (
    p: IExperiencesTableDateCell
) => {
    const { row } = p.cell;

    const rendered = p.rendered ? true : false;

    if (rendered) {
        const date_rendered = row.values.date_rendered
            ? formatDateDefault(row.values.date_rendered)
            : '- -';
        return <div>{date_rendered}</div>;
    } else {
        return <div>{formatDateDefault(row.values.date_created)}</div>;
    }
};

export default ExperiencesTableDateCell;
